import React, { ReactElement } from "react";
import { Table } from "antd";
import { AdsWithPdfNoConversionRecord } from "../../../redux/types/reportTypes";

export const columns = [
  {
    title: "Id",
    dataIndex: "id",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Cluster Id",
    dataIndex: "cluster_id",
  },
  {
    title: "Ad Id",
    dataIndex: "ad_id",
  },
  {
    title: "Ad Uuid",
    dataIndex: "ad_uuid",
  },
  {
    title: "Status",
    dataIndex: "status",
  },
  {
    title: "Created At",
    dataIndex: "created_at",
  },
  {
    title: "Start Date",
    dataIndex: "start_date",
  },
  {
    title: "End Date",
    dataIndex: "end_date",
  },
  {
    title: "Hashed From",
    dataIndex: "hashed_from",
  },
];

type AdsWithPdfNoConversionProps = {
  loading: boolean;
  records: Array<AdsWithPdfNoConversionRecord>;
};

const AdsWithPdfNoConversion = ({ loading, records }: AdsWithPdfNoConversionProps): ReactElement => (
  <Table
    dataSource={records}
    columns={columns}
    loading={loading}
    rowKey="id"
    pagination={false}
    scroll={{ y: 350, x: 3200 }}
  />
);

export default AdsWithPdfNoConversion;
